export const STUDY_TASK_MUTATIONS = {
  SET_STUDY_TASKS: 'SET_STUDY_TASKS',
  SET_ACTIVE_STUDY_TASK: 'SET_ACTIVE_STUDY_TASK',
  SET_SHOW_STUDY_TASK_MODAL: 'SET_SHOW_STUDY_TASK_MODAL'
};

export const STUDY_TASK_ACTIONS = {
  GET_MY_STUDY_TASKS: 'GET_MY_STUDY_TASKS',
  GET_MY_NEXT_STUDY_TASK: 'GET_MY_NEXT_STUDY_TASK',
  GET_ACTIVE_STUDY_TASK: 'GET_ACTIVE_STUDY_TASK',
  SET_ACTIVE_STUDY_TASK: 'SET_ACTIVE_STUDY_TASK',
  CLEAR_ACTIVE_STUDY_TASK: 'CLEAR_ACTIVE_STUDY_TASK'
};

export const STUDY_TASK_GETTERS = {
  MY_STUDY_TASKS: 'MY_STUDY_TASKS',
  ACTIVE_STUDY_TASK: 'ACTIVE_STUDY_TASK',
  SHOW_STUDY_TASK_MODAL: 'SHOW_STUDY_TASK_MODAL',
  MY_STUDY_TASKS_TODO_NOW_BY_GROUP: 'MY_STUDY_TASKS_TODO_NOW_BY_GROUP',
  MY_STUDY_TASKS_TODO_NOW: 'MY_STUDY_TASKS_TODO_NOW'
};
